export enum PlanType {
    Silver = 1,
    Gold = 2,
    Platinum = 3,
    All = 0  // display all three PlanPremium
}